export interface ContactDetails {
  mailingAddress: string;
  additionalAddress: string;
  city: string;
  state: string;
  zip: string;
  phoneNumber: string;
  mobileNumber: string;
  emailAddress: string;
}

export const EmptyContactDetails: ContactDetails = {
  mailingAddress: '',
  additionalAddress: '',
  city: '',
  state: '',
  zip: '',
  phoneNumber: '',
  mobileNumber: '',
  emailAddress: '',
};
